export const exponentialRetryDelay = (
  attemptIndex: number,
  maximumDelayMs: number,
) => Math.min(1000 * 2 ** attemptIndex, maximumDelayMs);
